module.exports = __webpack_public_path__ + "static/sync-api-152a18581acb443d5d7675b0cf8798f2.webp";